/**
 * Tooltip Content Definitions
 * Central repository for all business definitions of KPIs and metrics.
 */

export const TOOLTIP_CONTENT = {
  // Enterprise KPIs
  forecast_accuracy: {
    title: "Forecast Accuracy (FA)",
    content: "The percentage of how close the predicted demand was to actual sales results. High accuracy reduces stockouts and excess inventory."
  },
  forecast_bias: {
    title: "Forecast Bias (FB)",
    content: "Measures if the system is consistently over-forecasting (Positive Bias) or under-forecasting (Negative Bias). Goal is to stay close to 0."
  },
  dio: {
    title: "Days Inventory Outstanding",
    content: "The average number of days it takes for inventory to be turned into sales. Lower numbers indicate better inventory health."
  },
  dos: {
    title: "Days of Supply",
    content: "The number of days of inventory remaining at the current demand rate. Lower DoS means inventory will run out sooner."
  },
  z_score: {
    title: "z-score",
    content: "A statistical deviation measure. Higher z-scores indicate more anomalous or spike-like behavior versus the average."
  },
  otif: {
    title: "On-Time In-Full",
    content: "The percentage of customer orders that were delivered exactly as requested and on the promised date."
  },

  // Demand Components
  total_forecast: {
    title: "Total Forecast Demand",
    content: "The sum of baseline demand and any incremental lifts from promotions or seasonal events."
  },
  base_demand: {
    title: "Base Demand",
    content: "The underlying 'normal' demand for a product, calculated from historical day-of-week and trend patterns without promotional effects."
  },
  promo_demand: {
    title: "Promotional Demand",
    content: "The additional demand generated specifically by marketing events, price discounts, or displays."
  },

  // Analysis Metrics
  avg_lift: {
    title: "Average Promotional Lift",
    content: "The expected percentage increase in demand during a promotional period compared to the non-promotional baseline."
  },
  promo_frequency: {
    title: "Historical Promo Frequency",
    content: "The percentage of days in the historical dataset where a promotion was active for this specific SKU or Location."
  },
  promo_records: {
    title: "Historical Promo Records",
    content: "The total number of promotional entries discovered in the historical dataset used to train this model."
  },

  // Data Quality
  historical_records: {
    title: "Historical Data Strength",
    content: "The depth of historical records available for this analysis. More records generally lead to higher confidence in the baseline."
  },
  data_source: {
    title: "Data Reliability",
    content: "Indicates whether the forecast is based on the hybrid LightGBM + Prophet predictions or if the system had to use a synthetic fallback due to data gaps."
  },
  
  // Specific Aggregations
  promo_base_ratio: {
    title: "Promo-to-Base Ratio",
    content: "Calculates the magnitude of promotional impact versus normal sales. A 2.0x ratio means promotions double the baseline demand."
  },
  intensity: {
    title: "Promotion Intensity",
    content: "A qualitative measure of how heavily the selected period is impacted by promotional activities."
  },

  // Baseline & FVA
  fva: {
    title: "Forecast Value Add (FVA)",
    content: "Measures how much value the deterministic forecast engine adds over the statistical baseline. Positive FVA = the model outperforms the baseline. Negative FVA = the baseline is actually more accurate. Target: > 0%."
  },
  sma_baseline: {
    title: "SMA Baseline",
    content: "A simple moving average baseline computed from the selected historical demand window. It represents the non-promotional demand profile that the forecast model should outperform."
  },
};
